
const REBRAND_MONTHLY_PRICE_ID = process.env.REACT_APP_STRIPE_REBRAND_MONTHLY || '';
const REBRAND_YEARLY_PRICE_ID = process.env.REACT_APP_STRIPE_REBRAND_YEARLY || '';
const REBRAND_PRICE_ONE_ID = process.env.REACT_APP_STRIPE_REBRAND_ONE || '';

const REBRAND_BUNDLE_PRICE_0_10_3M = process.env.REACT_APP_REBRAND_BUNDLE_0_10_3M || "";
const REBRAND_BUNDLE_PRICE_0_10_6M = process.env.REACT_APP_REBRAND_BUNDLE_0_10_6M || "";
const REBRAND_BUNDLE_PRICE_0_25_6M = process.env.REACT_APP_REBRAND_BUNDLE_0_25_6M || "";
const REBRAND_BUNDLE_PRICE_0_25_12M = process.env.REACT_APP_REBRAND_BUNDLE_0_25_12M || "";
const REBRAND_BUNDLE_PRICE_0_55_12M = process.env.REACT_APP_REBRAND_BUNDLE_0_55_12M || "";
const STANDARD_PRICE_ID = process.env.REACT_APP_STANDARD_BASE || "";

const OLD_STANDARD = process.env.REACT_APP_MONTHLY_PLAN_ID || "";
const OLD_REBRAND_MONTH = process.env.REACT_APP_STRIPE_REBRAND_MONTHLY || "";
const OLD_REBRAND_YEAR = process.env.REACT_APP_STRIPE_REBRAND_YEARLY || "";
const OLD_REBRAND_LIFETIME = process.env.REACT_APP_STRIPE_REBRAND_ONE || "";


export interface Option {
  id: string;
  priceId: string;
  label: string;
  clients?: string;
  period?: string;
}

export const standardOptions: Option[] = [
  { id: "standard", priceId: STANDARD_PRICE_ID, label: "Starting from 7.49€", },
];

export const rebrandOptions: Option[] = [
  { id: "rebrand_month", priceId: REBRAND_MONTHLY_PRICE_ID, label: "Monthly 19.99€" },
  { id: "rebrand_yearly", priceId: REBRAND_YEARLY_PRICE_ID, label: "Yearly 144.99€" },
  { id: "rebrand_lifetime", priceId: REBRAND_PRICE_ONE_ID, label: "Lifetime 246.99€" },
];

export const oldOptions: Option[] = [
  {id: "standard", priceId: OLD_STANDARD, label: "Standard"},
  { id: "rebrand_month", priceId: OLD_REBRAND_MONTH, label: "Monthly 19.99€" },
  { id: "rebrand_yearly", priceId: OLD_REBRAND_YEAR, label: "Yearly 144.99€" },
  { id: "rebrand_lifetime", priceId: OLD_REBRAND_LIFETIME, label: "Lifetime 246.99€" },
];

export const bundleOptions: Option[] = [
  { id: "REBRAND_BUNDLE_0_10_3M", priceId: REBRAND_BUNDLE_PRICE_0_10_3M, label: "0-10 Cl 3M 94€", clients: "0-10", period: "3M" },
  { id: "REBRAND_BUNDLE_0_10_6M", priceId: REBRAND_BUNDLE_PRICE_0_10_6M, label: "0-10 Cl 6M 169€", clients: "0-10", period: "6M" },
  { id: "REBRAND_BUNDLE_0_25_6M", priceId: REBRAND_BUNDLE_PRICE_0_25_6M, label: "0-25 Cl 6M 306€", clients: "0-25", period: "6M"  },
  { id: "REBRAND_BUNDLE_0_25_12M", priceId: REBRAND_BUNDLE_PRICE_0_25_12M, label: "0-25 Cl 12M 488€", clients: "0-25", period: "12M"  },
  { id: "REBRAND_BUNDLE_0_55_12M", priceId: REBRAND_BUNDLE_PRICE_0_55_12M, label: "0-55 Cl 12M 599€", clients: "0-55", period: "12M"  },
];

export const allBillingOptions = [...standardOptions, ...rebrandOptions, ...bundleOptions];
export const billingOptionsByPriceId: Record<string, Option> = Object.fromEntries(
  allBillingOptions.map((option) => [option.priceId, option])
);
